/** @format */

const colors = {
  blueIcon: '#3366cc',
  primary: '#0099A8',
  lightOrange: '#fff0b3',
  darkPrimary: '#067985', // legacy, non utilizzare
  red: '#DD0031',
  darkRed: '#AA0E26', // legacy, non utilizzare
  lightYellow: '#fffdd0',
  yellow: '#FFCE00',
  darkYellow: '#CDA600', // legacy, non utilizzare
  orange: '#FF671B',
  darkOrange: '#C8581E', // legacy, non utilizzare
  green: '#77BC1F',
  darkGreen: '#52811D', // legacy, non utilizzare
  blue: '#005CB9',
  marinBlue: '#2ED9C3',
  darkBlue: '#00498C', // legacy, non utilizzare
  purple: '#D0009E',
  darkPurple: '#941E6C', // legacy, non utilizzare
  grey: '#D9D9D9',
  darkGrey: '#8A8A8D',
  greyInput: '#ECECEC',
  greyCardInclusione: '#F5F5F5',
  greyFooter: '#B8B8B8',
  white: '#ffffff',
  heavyMetal: '#1D1D1B',
  black: '#55565A',
  darkBlack: '#000000',
  inherit: 'inherit',
  greyFooterText: '#595858',
};

export const valuesColor = Object.keys(colors);

export default colors;
